import {
  FETCH_IDENTITY,
  UPDATE_ACCOUNT,
  REFRESH_API_TOKEN,
  UPDATE_USER,
  FETCH_ACTIVITIES,
  UPDATE_ACCOUNT_IMAGE
} from "./types";
import { LOGOUT } from "@/store/auth/types";
import actions from "./actions";
import {
  errorMutations,
  loadingMutations,
  resetErrorsAndLoading,
  getter
} from "@/store/utils";
import Vue from "vue";

const state = {
  // global loader looking at this prop
  identityLoading: false,
  isLoading: false,
  apiKeysLoading: false,
  identity: null,
  identityLoaded: false,
  errors: null,
  activities: []
};

const getters = {
  getUser: state => (state.identity ? state.identity.user : null),
  getAccount: state => (state.identity ? state.identity.account : null),
  getFullName: state =>
    state.identity
      ? `${state.identity.user.first_name} ${state.identity.user.last_name}`
      : "",
  getContactActivities: state => contactId =>
    state.activities.filter(item => item.contact_id === contactId),
  identityLoading: getter("identityLoading"),
  isLoading: getter("isLoading"),
  apiKeysLoading: getter("apiKeysLoading"),
  identity: getter("identity"),
  identityLoaded: getter("identityLoaded"),
  activities: getter("activities")
};

const mutations = {
  [UPDATE_ACCOUNT.success](state, { payload }) {
    if (state.identity) {
      Vue.set(state, "identity", {
        user: {
          ...state.identity.user,
          ...payload.user
        },

        account: {
          ...state.identity.account,
          ...payload.account
        }
      });
    }
    resetErrorsAndLoading(state);
  },

  [FETCH_IDENTITY.success](state, { payload }) {
    Vue.set(state, "identity", payload);
    Vue.set(state, "identityLoading", false);
    Vue.set(state, "identityLoaded", true);
  },

  [FETCH_IDENTITY.error](state, { payload }) {
    Vue.set(state, "errors", payload);
    Vue.set(state, "identityLoading", false);
    Vue.set(state, "identityLoaded", true);
  },

  [LOGOUT.success](state) {
    Vue.set(state, "identity", null);
  },

  [UPDATE_ACCOUNT_IMAGE.success](state, { payload }) {
    Vue.set(state.identity.user, "profile_image_url", payload);
    resetErrorsAndLoading(state);
  },

  [UPDATE_USER.success](state, { payload }) {
    Vue.set(state.identity, "user", payload);
    resetErrorsAndLoading(state);
  },

  [REFRESH_API_TOKEN.request](state) {
    Vue.set(state, "apiKeysLoading", true);
  },

  [REFRESH_API_TOKEN.success](state) {
    Vue.set(state, "apiKeysLoading", false);
    resetErrorsAndLoading(state);
  },

  [REFRESH_API_TOKEN.error](state) {
    Vue.set(state, "apiKeysLoading", false);
  },

  [FETCH_ACTIVITIES.success](state, { payload }) {
    Vue.set(state, "activities", payload);
    resetErrorsAndLoading(state);
  },

  ...loadingMutations([FETCH_IDENTITY.request], "identityLoading"),
  ...loadingMutations([
    UPDATE_ACCOUNT.request,
    UPDATE_USER.request,
    FETCH_ACTIVITIES.request,
    UPDATE_ACCOUNT_IMAGE.request
  ]),
  ...errorMutations([
    UPDATE_ACCOUNT.error,
    UPDATE_USER.error,
    FETCH_ACTIVITIES.error,
    UPDATE_ACCOUNT_IMAGE.error
  ])
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
